export default "__VITE_ASSET__3c703508__"